//获取选择地区选项
import {validatenull} from './validate'
import {toYYYYmmddFullDate} from './dateUtil'
import {clearHtml, getPageId} from './commonUtils'

export function clearEmptyData(data) {
	if (validatenull(data)) {
		return data
	}
	for (let dataKey in data) {
		//带$的删除
		if (dataKey.includes('$')) {
			delete data[dataKey]
		}
		if (validatenull(data[dataKey])) {
			delete data[dataKey]
		}
	}
	return data
}

export const unitFormDataAll = {
	areaCode: '',
	businessScope: '',
	//营业执照
	certImgFront: '',
	category: '',
	email: '',
	idNo: '',
	identityBack: '',
	identityFront: '',
	industry: '',
	legalPerson: '',
	legalPersonMobile: '',
	registeredCapital: '',
	same: true,
	termExpiry: '',
	termType: '',
	addr: '',
	name: '',
	certNo: '',
	certType: '',
	businessType: '',
	registryCapital: '',
}

export function getAreaCodeList(verifies = [], tempList = []) {
	let verifyData = verifies.find(({matchType = -1}) => {
		return matchType === 23
	})
	if (!validatenull(verifyData)) {
		let {provinceLimit = '', cityLimit = ''} = JSON.parse(verifyData.value) || {}
		//处理省级
		if (provinceLimit !== '') {
			tempList = tempList.find(({areaCode}) => {
				return new RegExp(provinceLimit).test(areaCode)
			})
		}
		//处理市
		if (cityLimit !== '') {
			tempList.children = tempList.children.filter(({areaCode}) => {
				return new RegExp(cityLimit).test(areaCode)
			})
		}
	}
	return tempList instanceof Array ? tempList : [tempList] || []
}

//判断数据是否符合限制
export function isAbleAreaCode(verifies = [], value = '') {
	let verifyData = verifies.find(({matchType = -1}) => {
		return matchType === 23
	})
	if (!validatenull(verifyData)) {
		let {provinceLimit = '', cityLimit = ''} = JSON.parse(verifyData.value) || {}
		if (cityLimit !== '') {
			return new RegExp(cityLimit).test(value)
		}
		//处理省级
		if (provinceLimit !== '') {
			return new RegExp(provinceLimit).test(value)
		}
	}
	return true
}

//结构选择历史企业数据
export function getUnitHistoryData(unitFormData, unitData) {
	let {
		unitName = '',
		unitCode = '',
		legalPerson = '',
		legalPersonMobile = '',
		areaCode = '',
		unitAddr = '',
		busLicense = '',
		industry = '',
		category = '',
		identityFront = '',
		identityBack = '',
		registerCapital = '',
		termType = '',
		termStart = '',
		termEnd = '',
		businessScope = '',
		termExpiry = '',
		idNo = '',
	} = unitData

	unitFormData.name = unitName
	unitFormData.certNo = unitCode
	unitFormData.legalPerson = legalPerson
	unitFormData.legalPersonMobile = legalPersonMobile
	unitFormData.areaCode = areaCode
	unitFormData.addr = unitAddr
	unitFormData.certImgFront = busLicense

	unitFormData.industry = ''
	unitFormData.category = ''
	unitFormData.identityFront = identityFront
	unitFormData.identityBack = identityBack
	if (registerCapital !== '') {
		unitFormData.registerCapital = registerCapital
	}
	unitFormData.termType = !termType ? '' : termType + ''
	try {
		unitFormData.termStart = getTermData(termStart)
		unitFormData.termEnd = getTermData(termEnd)
	} catch (e) {
		unitFormData.termStart = ''
		unitFormData.termEnd = ''
	}
	//处理经营范围
	if (businessScope !== '' && businessScope.length > 35) {
		businessScope = businessScope.substring(0, 30)
	}
	unitFormData.businessScope = businessScope
	unitFormData.termExpiry = termExpiry
	unitFormData.idNo = idNo
}

//重新提交或者续保等导入数据
export function getTransIntoUnitData(unitFormData, tempData = {}) {
	if (!validatenull(tempData)) {
		let {
			sameUnit = true,
			unit_name = '',
			unit_code = '',
			legal_person = '',
			legal_person_mobile = '',
			area_code = '',
			unit_addr = '',
			bus_license = '',
			industry = '',
			category = '',
			identityFront = '',
			identityBack = '',
			registerCapital,
			termType = '',
			termStart = '',
			termEnd = '',
			businessScope = '',
			email = '',
		} = tempData || {}
		//赋值
		unitFormData.same = sameUnit
		unitFormData.name = unit_name || unitFormData.name
		unitFormData.certNo = unit_code || unitFormData.certNo
		unitFormData.legalPerson = legal_person || unitFormData.legalPerson
		unitFormData.legalPersonMobile = legal_person_mobile || unitFormData.legalPersonMobile
		unitFormData.areaCode = area_code || unitFormData.areaCode
		unitFormData.addr = unit_addr || unitFormData.addr
		unitFormData.certImgFront = bus_license || unitFormData.certImgFront

		unitFormData.industry = industry + ''
		unitFormData.category = category + ''
		unitFormData.identityFront = identityFront
		unitFormData.identityBack = identityBack
		unitFormData.registerCapital = registerCapital
		unitFormData.termType = termType + ''
		try {
			unitFormData.termStart = getTermData(termStart)
			unitFormData.termEnd = getTermData(termEnd)
		} catch (e) {
			unitFormData.termStart = ''
			unitFormData.termEnd = ''
		}
		//处理经营范围
		if (businessScope !== '' && businessScope.length > 35) {
			businessScope = businessScope.substring(0, 30)
		}
		unitFormData.businessScope = businessScope
		unitFormData.email = email
	}
}

//数据转换，insure数据 转产品中心数据
export function getProductCenterUnitData(unitData) {
	let {
		unit_name = '',
		unit_code = '',
		legal_person = '',
		legal_person_mobile = '',
		area_code = '',
		unit_addr = '',
		bus_license = '',
	} = unitData
	return {
		name: unit_name,
		certNo: unit_code,
		legalPerson: legal_person,
		legalPersonMobile: legal_person_mobile,
		areaCode: area_code,
		addr: unit_addr,
		certImgFront: bus_license,
	}
}

//校验企业转换的数据
export function getCheckUnitData(unitData) {
	let {name = '', certNo = '', addr = '', statementImg = '', businessScope = ''} = unitData
	//处理经营范围
	if (businessScope !== '' && businessScope.length > 35) {
		unitData.businessScope = businessScope.substring(0, 30)
	}
	let tempUnitData = Object.assign(unitData, {
		unitName: name,
		unitCode: certNo,
		unitAddress: addr,
		InsureConfirm: statementImg,
	})
	tempUnitData.name = ''
	tempUnitData.certNo = ''
	tempUnitData.addr = ''
	tempUnitData.statementImg = ''

	clearEmptyData(tempUnitData)

	return tempUnitData
}

//最后insure接口！！！！数据转换
export function getInsureUnitData(unitData) {
	let {
		name,
		certNo,
		certImgFront,
		same,
		areaCode,
		addr,
		legalPerson,
		legalPersonMobile,
		certType = '',
		type = '',
		...otherData
	} = unitData

	let tempData = {
		unit_name: name,
		unit_code: certNo,
		legal_person: legalPerson,
		legal_person_mobile: legalPersonMobile,
		sameUnit: same,
		area_code: areaCode,
		unit_addr: addr,
		bus_license: certImgFront,
		type,
		...otherData,
	}
	if (certType) {
		tempData.certType = certType
	}
	return clearEmptyData(tempData)
}

//投保人设置数据 美的光伏的不删remark
export function getTransEmpData(empList, isMore = false, isDelRemark = false) {
	return empList.map((itemData) => {
		let snData = getPageId()
		if (isMore) {
			return Object.assign(itemData, {sn: snData})
		}
		let {professionId = '', workType = '', remark = ''} = itemData
		if (professionId) {
			itemData.professionId = `${professionId}`
		}
		if (workType) {
			Object.assign(itemData, {workType: `${workType}`, feeRate: `${workType}`})
		}
		if (remark && isDelRemark) {
			//删除remark
			delete itemData.remark
		}
		return Object.assign(itemData, {$cellEdit: true, premium: 0, sn: snData})
	})
}

//特殊处理 termStart termEnd
export function getTermData(termData = '') {
	if (typeof termData === 'string') {
		if (validatenull(termData) || termData.length < 9) {
			return ''
		}
		if (termData.includes('-') || termData.includes('/') || termData.includes('年') || termData.includes(':')) {
			//强制转换
			return toYYYYmmddFullDate(new Date(termData).getTime())
		} else {
			return toYYYYmmddFullDate(parseInt(termData))
		}
	} else if (typeof termData === 'number') {
		if (termData > 0) {
			return toYYYYmmddFullDate(termData)
		}
	}
}

export function getPlanInsureData(tempPlanData) {
	let {
		unitData: {name = '', certNo = '', areaCode = ''} = {},
		period: {term = '', termUnit = ''} = {},
		empData = [],
		planData = [],
	} = JSON.parse(clearHtml(tempPlanData)) || {}
	let tempData = {
		//企业
		toubao: {
			unit_name: name,
			unit_code: certNo,
			area_code: areaCode,
		},
		coverage: planData[0].coverage,
		emps: [],
	}
	//如果 termUnit 存在，则 term 需要转换
	if (termUnit) {
		tempData.term = `${term}_${termUnit}`
	}
	//处理人员
	empData.forEach(({categoryCode = '', empNum = '', professionId = '', workType = ''}) => {
		for (let i = 0; i < parseInt(empNum); i++) {
			let empItem = {
				professionCode: categoryCode,
				professionId,
			}
			if (workType) {
				empItem.workType = workType
			}
			tempData.emps.push(empItem)
		}
	})
	return tempData
}

//批量投保重新提交，续保，数据转换
export function getMoreInsureData(subData) {
	let {coverage, term, termUnit, result = []} = subData
	let tempData = {
		term,
		termUnit,
		coverage,
		emps: [],
	}
	for (let resultElement of result) {
		let tempEmp = {}
		let {
			toubao: {unit_name, unit_code, legal_person_mobile, area_code, unit_addr},
			emps = [],
			sameUnit,
		} = resultElement
		let {empName, empIdNo, professionCode, professionId} = emps[0]
		tempEmp.name = unit_name
		tempEmp.certNo = unit_code
		tempEmp.legalPersonMobile = legal_person_mobile
		tempEmp.areaCode = area_code
		tempEmp.addr = unit_addr
		tempEmp.certType = '100'
		tempEmp.type = '2'
		tempEmp.empName = empName
		tempEmp.empIdNo = empIdNo
		tempEmp.professionId = professionId
		tempEmp.professionCode = professionCode
		tempEmp.same = sameUnit ? '1' : '2'
		tempEmp.$cellEdit = true
		tempEmp.premium = 0
		tempData.emps.push(tempEmp)
	}
	return tempData
}
